<template>
    <div ref="overviewWrapper"
         class="resource-overview">
        <div class="overview-content">
            <div style="height: 350px">
                <div class="search-content">
                    <div class="body-content">
                        <div>
                            <div class="body-content-line">
                                <dropDownList v-model="logicopt1"/>
                                <div class="body-content-line-content">{{langTransfer('期刊名称')}}：
                                    <input ref="magazinename"/>
                                </div>
                            </div>
                            <div class="body-content-line">
                                <dropDownList v-model="logicopt2"/>
                                <div class="body-content-line-content displayflex">
                                    {{langTransfer('年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;份')}}：
                                    <dropDownList v-model="yearsobj"/>
                                </div>
                            </div>
                            <!--<div class="body-content-line">
                                <dropDownList v-model="logicopt3"/>
                                <div class="body-content-line-content displayflex">
                                    {{langTransfer('期&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号')}}：
                                    <dropDownList v-model="issuesobj"/>
                                </div>
                            </div>-->
                            <div class="body-content-line">
                                <dropDownList v-model="logicopt4"/>
                                <div class="body-content-line-content">
                                    {{langTransfer('文章标题')}}：<input ref="articletitle"/>
                                </div>
                            </div>
                            <div class="body-content-line">
                                <dropDownList v-model="logicopt5"/>
                                <div class="body-content-line-content">
                                    {{langTransfer('文章片段')}}：<input  ref="articlecontent"/>
                                </div>
                            </div>
                            <div class="body-content-line">
                                <dropDownList v-model="logicopt6"/>
                                <div class="body-content-line-content">
                                    {{langTransfer('开始时间')}}：<input type='date' class="dateselect"  ref="startdate" required/>
                                    {{langTransfer('结束时间')}}：<input type='date' class="dateselect"  ref="enddate" required/>
                                </div>
                            </div>
                            <div class="body-content-line">
                                <dropDownList v-model="logicopt7"/>
                                <div class="body-content-line-content displayflex">
                                    <!--{{langTransfer('数据来源')}}：
                                    <dropDownList v-model="sourceobj"/>-->
                                    {{langTransfer('排序方式')}}：
                                    <dropDownList v-model="orderobj"/>
                                </div>
                            </div>
                            <div class="body-content-line">
                                <button :style="{background:themeColor}" @click="search">{{langTransfer('高级搜索')}}</button>
                            </div>
                        </div>
                    </div>     
                </div>    
            </div>
            <div class="site-footer"/>
            </div>
            <backBtn/>
        </div>
    </div>
</template>

<script>
    import backBtn from '@/components/backBtn'
    import dropDownList from '@/components/dropDownList'
    export default {
        components: {
            dropDownList,
            backBtn
        },
        data () {
            return {
                logiclist:['并且','或者','不含'],
                logicopt1:{ 
                    list:[],
                    selectvalue:0
                },
                logicopt2:{ 
                    list:[],
                    selectvalue:0
                },
                logicopt3:{ 
                    list:[],
                    selectvalue:0
                },
                logicopt4:{ 
                    list:[],
                    selectvalue:0
                },
                logicopt5:{ 
                    list:[],
                    selectvalue:0
                },
                logicopt6:{ 
                    list:[],
                    selectvalue:0
                },
                logicopt7:{ 
                    list:[],
                    selectvalue:0
                },
                orderobj:{ 
                    list:['默认','相关度','按时间'],
                    selectvalue:0
                },
                yearsobj:{
                    list:[],
                    selectvalue:0
                },
                issuesobj:{
                    list:[],
                    selectvalue:0
                }
                /*,
                sourceobj:{
                    list:['期刊'],
                    selectvalue:0
                }*/
            };
        },
        computed: {
            themeColor () {
                return this.$store.state.themeColor
            }
        },
        mounted()
        {
            this.createIssues();

            this.yearsobj.list.push('任意');
            for (var y = new Date().getFullYear(); y >= 2000; y--) {
               this.yearsobj.list.push(y);
            }
             
            this.logicopt1.list = this.logiclist;
            this.logicopt2.list = this.logiclist;
            this.logicopt3.list = this.logiclist;
            this.logicopt4.list = this.logiclist;
            this.logicopt5.list = this.logiclist;
            this.logicopt6.list = this.logiclist;
            this.logicopt7.list = this.logiclist;

            var now = new Date();
            var previousMonth = this.addMonths(now,-1);
            
            this.$refs.enddate.value =this.formatDate(now);
            this.$refs.startdate.value =this.formatDate(previousMonth);
        },
        methods:
        {
            formatDate(date)
            {
                let y = date.getFullYear();
                let m = (date.getMonth() + 1)<10?'0'+(date.getMonth() + 1):(date.getMonth() + 1);
                let d = date.getDate();
                return `${y}-${m}-${d}`;
            },
            addMonths(t,value){
                let result = new Date(t);
                result.setMonth(result.getMonth() + Math.floor(value));
                if(result.getDate() < t.getDate()){
                    result.setDate(0);
                }
                return result;
            },
            createIssues()
            {      
                this.issuesobj.list.push('任意');
                for (let i = 1; i <= 100; i++) {
                   this.issuesobj.list.push(i+'期');
                }
            },
            search()
            {
                if(!this.$refs.magazinename.value && !this.$refs.articletitle.value && !this.$refs.articlecontent.value)
                {   

                    this.$toasted.show(this.langTransfer('请至少填写期刊名称、文章标题、文章片段中的一种'), { 
                         theme: "toasted-primary", 
                         position: "top-center", 
                         keepOnHover:true,
                         duration:2000,
                         containerClass:'messageContainerClass'
                    })           
                    return;
                }

                //(pageNumber,pageSize,sortType,title,titleLogic,content,contentLogic,minDate,minDateLogic,
                //maxDate,maxDateLogic,magazineName,magazineNameLogic,year,yearLogic,issue,issueLogic
                this.$router.push({
                    name:'advancedSearchResults',  
                    params:{
                        sourcetype:1,
                        pageNumber:1,
                        magazineName:this.$refs.magazinename.value?this.$refs.magazinename.value:'magazineName',
                        magazineNameLogic:this.logicopt1.selectvalue,
                        year:this.yearsobj.list[this.yearsobj.selectvalue].toString().replace(/[^\d]/g,'')*1,
                        yearLogic:this.logicopt2.selectvalue,
                        issue:this.issuesobj.list[this.issuesobj.selectvalue].toString().replace(/[^\d]/g,'')*1,
                        issueLogic:this.logicopt3.selectvalue,
                        title:this.$refs.articletitle.value?this.$refs.articletitle.value:'title',
                        titleLogic:this.logicopt4.selectvalue,
                        content:this.$refs.articlecontent.value?this.$refs.articlecontent.value:'content',
                        contentLogic:this.logicopt5.selectvalue,
                        minDate:this.$refs.startdate.value?this.$refs.startdate.value:'minDate',
                        minDateLogic:this.logicopt6.selectvalue,
                        maxDate:this.$refs.enddate.value?this.$refs.enddate.value:'maxDate',
                        maxDateLogic:this.logicopt6.selectvalue,                        
                        sortType:this.orderobj.selectvalue,
                    }
                });
            }
        },
        beforeRouteEnter (to, from, next) {         
            next((vm)=>{
                vm.logicopt1.selectvalue = 0;
                vm.logicopt2.selectvalue = 0; 
                vm.logicopt3.selectvalue = 0; 
                vm.logicopt4.selectvalue = 0; 
                vm.logicopt5.selectvalue = 0; 
                vm.logicopt6.selectvalue = 0;  
                vm.logicopt7.selectvalue = 0; 
                vm.yearsobj.selectvalue = 0;
                vm.issuesobj.selectvalue = 0;
                vm.orderobj.selectvalue = 0;
                vm.$refs.magazinename.value = '';
                vm.$refs.articletitle.value = '';
                vm.$refs.articlecontent.value = '';
                window.scrollTo(0, 0); 
                /*vm.sourceobj.selectvalue = 0;*/
            });
        }
    }
</script>

<style type="text/css">
         
</style>
<style lang="scss" scoped>
    
     .resource-overview {
        width: 100%;
        height: 100%;
        overflow: hidden; 
     }   
     .overview-content {
            width: 1140px;
            margin: 40px auto 0 auto;
     }
    .search-content {
           
        .body-content
        {
            &>div{
                width: 619px;
                font-size: 14px;
                margin:0 auto;
                .displayflexjustcenter{
                        justify-content: center;
                        height: 100px !important;
                    }
                .body-content-line{
                    display: flex;
                    height: 44px;
                    .dateselect{
                         width: 160px !important;
                         margin-right: 20px;
                    }
                    button{
                        width: 100px;
                        height: 40px;
                        -webkit-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
                        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
                        border-radius: 4px;
                        margin-right: 10px;
                        color: white;
                    }

                    .body-content-line-content{
                       input{
                         border: 1px solid #979797;
                         width: 414px;
                         height: 24px;
                         border-radius: 4px;
                         background:white;
                       } 
                    }
                    .displayflex{
                        display: flex
                    }
                    
                }
            }  
        }     
            
    }
</style>